module.exports = __webpack_public_path__ + "img/bg-mid-768.f094f57c.png";